import type { ICustomCategoryResponse } from "app/services/category/userCustomCategoryService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

export const createMarket = (industryName: string, segmentGroupId: string): Promise<ICustomCategoryResponse[]> => {
    const createMarketPromise = UserCustomCategoryService.addCustomCategoryFromSegmentCompatison({
        industryName,
        segmentGroupId,
    });
    return createMarketPromise;
};
